import React, { useContext } from "react";

import _ from "app/lang";
import User from "app/models/User";
import { pageContext, PartialContext } from "app/page/ContextProvider";

import DrawerMenu, { DrawerMenuItem } from "./DrawerMenu";

export function getMenuItems(context: PartialContext) {
    if (!context.smartNVR) {
        return [];
    }

    const user = new User(context);
    const isCloudAdmin =  (user.role === "ROLE_OWNER" || user.role === "ROLE_ADMIN");

    const legacyUrl = "/smartnvr/:smartnvrId";
    const fe2Url = "/v2/cloud/:cloudId/smartnvr/:smartnvrId";

    // Until the installed NVR connects for the first time, only the
    // dashboard (setup guide) is usable — everything else is greyed out.
    const pendingSetup = context.smartNVR.state_id === "STATE_PENDING_REG"
        ? { disabled: true, disabledTooltip: _("Available after your NVR connects") }
        : {};

    const items: DrawerMenuItem[] = [
        {
            icon: "dashboard",
            text: _("Dashboard"),
            href: `${legacyUrl}/dashboard`
        },
        {
            icon: "ip_camera",
            text: _("IP Cameras"),
            href: `${fe2Url}/ipcams`,
            ...pendingSetup
        },
        {
            icon: "videocam",
            text: _("Streaming"),
            href: `${fe2Url}/streaming`,
            ...pendingSetup
        }
    ];

    if (isCloudAdmin) {
        items.push({
            icon: "gear",
            text: _("Tunnel Management"),
            href: `${fe2Url}/tunnels`,
            ...pendingSetup
        });
    }

    items.push({
        icon: "place",
        text: _("Maps"),
        ...pendingSetup,
        subitems: [
            {
                icon: "google_maps",
                text: _("Google Map"),
                href: `${legacyUrl}/google-map`,
                ...pendingSetup
            },
            {
                icon: "map",
                text: _("Floor Maps"),
                href: `${legacyUrl}/floor-maps`,
                ...pendingSetup
            }
        ]
    });

    items.push({
        icon: "list_alt",
        text: _("Activity"),
        href: `${legacyUrl}/activity`,
        ...pendingSetup
    });

    return items;
}

export default function SNVRMenu() {
    const context = useContext(pageContext);
    const items = getMenuItems(context);

    return <DrawerMenu items={items} />;
}
